module.exports = __webpack_public_path__ + "static/img/pro04.7625415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/pro04.jpg
// module id = RhJ+
// module chunks = 1